import * as Yup from "yup";

const schema = Yup.object().shape({
    zonas_codigo: Yup.string().required("Sigla é obrigatório"),
    zonas_tipo: Yup.string().required("Nome Zona, Eixo ou Setor é obrigatório"),
    zonas_descricao: Yup.string().required(
        "Descrição (características predominantes é obrigatório"
    ),
    zonas_leis_permitidas: Yup.string().required("Uso - Permitido | Adequado"),
    zonas_leis_permissivas: Yup.string().required("Uso - Permitido | Adequado"),
    zonas_leis_proibidas: Yup.string().required("Uso - Proibido"),
    zonas_cnaes_permitidos: Yup.string().required(
        "CNAEs Permitidos obrigatórios"
    ),
});

export const zonesValidator = async (payload: unknown) => {
    await schema.validate(payload, {
        abortEarly: false,
    });
};
